import React from 'react';

import { Media } from '../../contexts/media/MediaContext';
import useFeatureToggle from '../../hooks/use-feature-toggle/useFeatureToggle';
import { FeatureToggle, TableContent } from '../../models/app-data-model';
import TableHeading from './table-heading/table-heading';
import TableRow from './table-row/table-row';
import './table.scss';

export type TableProps = {
  content: TableContent;
  featureToggles: FeatureToggle[];
};

export const tableLayout = {
  centered: 'Centered',
  wide: 'Wide'
};

const Table: React.FC<TableProps> = ({ content, featureToggles }: TableProps) => {
  const useTableComponent: boolean = useFeatureToggle('table-component', featureToggles);

  if (!useTableComponent) {
    return null;
  }

  const totalRows = content?.column?.[0].row?.length || 0;
  const tableRows = [];
  for (let i = 0; i < totalRows; i++) {
    const tableRow = content?.column?.map((column) => {
      return { ...column?.row?.[i], highlight_column: column?.highlight_column };
    });
    tableRows.push(tableRow);
  }

  const tableRowRendering = tableRows?.map((row, index) => <TableRow row={row} key={index} />);

  const tableHeadingRendering = content?.column?.map((column, index) => <TableHeading heading={column?.column_heading} key={index} />);

  return (
    <>
      <Media greaterThanOrEqual="desktop">
        <div className="table-container desktop-table">
          <table className={content.layout === tableLayout.centered ? 'centered' : 'wide'}>
            <tr>{tableHeadingRendering}</tr>
            {tableRowRendering}
          </table>
        </div>
      </Media>

      <Media lessThan="desktop">
        <div className="table-container mobile-table">
          <table className={content.first_column_sticky ? 'first-column-sticky' : ''}>
            <tr>{tableHeadingRendering}</tr>
            {tableRowRendering}
          </table>
        </div>
      </Media>
    </>
  );
};

export default Table;
